const ADMIN_TITLE_PREFIX = 'SKU库存警戒提醒 - '

/**
 * 未确认通知按弹窗页分组：其它系统提示在前，库存告警按客户一页。
 * 新格式已是一客户一条；旧的「按 SKU 一条」按正文邮箱临时合成客户页。
 */
export function groupUnconfirmedNotifies(list) {
  if (!list || !list.length) {
    return []
  }
  const others = []
  const newStock = []
  const oldStock = []
  list.forEach(item => {
    if (item.notifyType !== 'STOCK_ALERT') {
      others.push(item)
      return
    }
    if (isCustomerDigest(item)) {
      newStock.push(item)
    } else {
      oldStock.push(item)
    }
  })
  return others.concat(newStock, groupOldStockByCustomer(oldStock))
}

function isCustomerDigest(item) {
  const title = item.title || ''
  if (title.indexOf(ADMIN_TITLE_PREFIX) === 0 && title.indexOf('@') > -1) {
    return true
  }
  return !!(item.content && item.content.indexOf('data-customer-alert') > -1)
}

function groupOldStockByCustomer(oldStock) {
  if (!oldStock.length) {
    return []
  }
  const byEmail = {}
  const leftovers = []
  oldStock.forEach(item => {
    const parsed = parseOldStockNotify(item)
    if (!parsed.users.length) {
      leftovers.push(item)
      return
    }
    parsed.users.forEach(user => {
      if (!byEmail[user.email]) {
        byEmail[user.email] = {
          email: user.email,
          children: [],
          rows: [],
          createTime: item.createTime
        }
      }
      const group = byEmail[user.email]
      group.children.push(item)
      group.rows.push({
        sku: parsed.sku,
        productTitle: parsed.productTitle,
        quantity: user.quantity,
        alertThreshold: user.threshold
      })
      if (item.createTime && (!group.createTime || item.createTime > group.createTime)) {
        group.createTime = item.createTime
      }
    })
  })
  const grouped = Object.keys(byEmail).sort().map(email => {
    const group = byEmail[email]
    return {
      id: 'merged-' + email,
      isMerged: true,
      mergedIds: uniqueIds(group.children),
      notifyType: 'STOCK_ALERT',
      title: ADMIN_TITLE_PREFIX + email,
      publisher: 'System',
      createTime: group.createTime,
      content: buildCustomerTableHtml(email, group.rows)
    }
  })
  return grouped.concat(leftovers)
}

function parseOldStockNotify(item) {
  const content = item.content || ''
  const skuMatch = content.match(/SKU:\s*([^<]+)/)
  const productMatch = content.match(/产品:\s*([^<]+)/)
  const usersMatch = content.match(/相关用户信息:\s*([^<]+)/)
  const sku = skuMatch ? skuMatch[1].trim() : ((item.title || '').replace(ADMIN_TITLE_PREFIX, '').trim())
  const productTitle = productMatch ? productMatch[1].trim() : ''
  const users = []
  if (usersMatch) {
    usersMatch[1].split(/\)\s*,\s*/).forEach(part => {
      const withQty = part.match(/(\S+@\S+)\s*\(库存:\s*(-?\d+),\s*警戒线:\s*(-?\d+)/)
      if (withQty) {
        users.push({
          email: withQty[1],
          quantity: Number(withQty[2]),
          threshold: Number(withQty[3])
        })
        return
      }
      const thresholdOnly = part.match(/(\S+@\S+)\s*\(警戒线:\s*(-?\d+)/)
      if (thresholdOnly) {
        users.push({
          email: thresholdOnly[1],
          quantity: null,
          threshold: Number(thresholdOnly[2])
        })
      }
    })
  }
  return { sku, productTitle, users }
}

function buildCustomerTableHtml(email, rows) {
  const body = rows.map(row => {
    return '<tr><td>' + escapeHtml(row.sku) + '</td><td>' + escapeHtml(row.productTitle)
      + '</td><td>' + (row.quantity == null ? '-' : row.quantity)
      + '</td><td>' + (row.alertThreshold == null ? '-' : row.alertThreshold) + '</td></tr>'
  }).join('')
  return '<div data-customer-alert="' + escapeHtml(email) + '">'
    + '<p>客户：' + escapeHtml(email) + ' 共 ' + rows.length + ' 个SKU低于警戒线，请及时补货。</p>'
    + '<table class="stock-alert-table" cellpadding="0" cellspacing="0" border="1" style="width:100%;border-collapse:collapse;margin-top:12px;">'
    + '<thead><tr><th>SKU</th><th>产品</th><th>库存</th><th>警戒线</th></tr></thead>'
    + '<tbody>' + body + '</tbody></table></div>'
}

function uniqueIds(items) {
  const seen = {}
  const ids = []
  items.forEach(item => {
    if (item.id && !seen[item.id]) {
      seen[item.id] = true
      ids.push(item.id)
    }
  })
  return ids
}

function escapeHtml(value) {
  if (value == null) {
    return ''
  }
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
}
